/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FuelUpPrestigeResponse } from './FuelUpPrestigeResponse';
import {
    FuelUpPrestigeResponseFromJSON,
    FuelUpPrestigeResponseFromJSONTyped,
    FuelUpPrestigeResponseToJSON,
    FuelUpPrestigeResponseToJSONTyped,
} from './FuelUpPrestigeResponse';
import type { FuelUpGameStateResponse } from './FuelUpGameStateResponse';
import {
    FuelUpGameStateResponseFromJSON,
    FuelUpGameStateResponseFromJSONTyped,
    FuelUpGameStateResponseToJSON,
    FuelUpGameStateResponseToJSONTyped,
} from './FuelUpGameStateResponse';
import type { FuelUpVaultState } from './FuelUpVaultState';
import {
    FuelUpVaultStateFromJSON,
    FuelUpVaultStateFromJSONTyped,
    FuelUpVaultStateToJSON,
    FuelUpVaultStateToJSONTyped,
} from './FuelUpVaultState';

/**
 * 
 * @export
 * @interface GetFuelUpGameStateResponse
 */
export interface GetFuelUpGameStateResponse {
    /**
     * 
     * @type {FuelUpGameStateResponse}
     * @memberof GetFuelUpGameStateResponse
     */
    gameState: FuelUpGameStateResponse;
    /**
     * 
     * @type {FuelUpVaultState}
     * @memberof GetFuelUpGameStateResponse
     */
    vault?: FuelUpVaultState;
    /**
     * 
     * @type {FuelUpPrestigeResponse}
     * @memberof GetFuelUpGameStateResponse
     */
    prestige?: FuelUpPrestigeResponse;
    /**
     * Configurable dollars-per-move setting from SiteConfiguration
     * @type {number}
     * @memberof GetFuelUpGameStateResponse
     */
    dollarsPerMove: number;
    /**
     * 
     * @type {Array<object>}
     * @memberof GetFuelUpGameStateResponse
     */
    allVaultBonusTiers: Array<object>;
}

/**
 * Check if a given object implements the GetFuelUpGameStateResponse interface.
 */
export function instanceOfGetFuelUpGameStateResponse(value: object): value is GetFuelUpGameStateResponse {
    if (!('gameState' in value) || value['gameState'] === undefined) return false;
    if (!('dollarsPerMove' in value) || value['dollarsPerMove'] === undefined) return false;
    if (!('allVaultBonusTiers' in value) || value['allVaultBonusTiers'] === undefined) return false;
    return true;
}

export function GetFuelUpGameStateResponseFromJSON(json: any): GetFuelUpGameStateResponse {
    return GetFuelUpGameStateResponseFromJSONTyped(json, false);
}

export function GetFuelUpGameStateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFuelUpGameStateResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'gameState': FuelUpGameStateResponseFromJSON(json['gameState']),
        'vault': json['vault'] == null ? undefined : FuelUpVaultStateFromJSON(json['vault']),
        'prestige': json['prestige'] == null ? undefined : FuelUpPrestigeResponseFromJSON(json['prestige']),
        'dollarsPerMove': json['dollarsPerMove'],
        'allVaultBonusTiers': json['allVaultBonusTiers'],
    };
}

export function GetFuelUpGameStateResponseToJSON(json: any): GetFuelUpGameStateResponse {
    return GetFuelUpGameStateResponseToJSONTyped(json, false);
}

export function GetFuelUpGameStateResponseToJSONTyped(value?: GetFuelUpGameStateResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gameState': FuelUpGameStateResponseToJSON(value['gameState']),
        'vault': FuelUpVaultStateToJSON(value['vault']),
        'prestige': FuelUpPrestigeResponseToJSON(value['prestige']),
        'dollarsPerMove': value['dollarsPerMove'],
        'allVaultBonusTiers': value['allVaultBonusTiers'],
    };
}

